import React from "react";

const Circle = ({ additionalStyles }) => (
  <svg width="205px" height="280px" viewBox="0 0 750 750" version="1.1">
  <title>Oval</title>
  <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
          <stop stopColor="#F6E05E" offset="0%"></stop>
          <stop stopColor="#A0F2F2" offset="52.8674642%"></stop>
          <stop stopColor="#165659" offset="100%"></stop>
      </linearGradient>
  </defs>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
      <g id="Map-1" transform="translate(-345, -97)" fill="url(#linearGradient-1)" fillRule="nonzero">
          <path d="M720,97 C927.106781,97 1095,264.893219 1095,472 C1095,679.106781 927.106781,847 720,847 C512.893219,847 345,679.106781 345,472 C345,264.893219 512.893219,97 720,97 Z M720,112 C521.17749,112 360,273.17749 360,472 C360,670.82251 521.17749,832 720,832 C918.82251,832 1080,670.82251 1080,472 C1080,273.17749 918.82251,112 720,112 Z" id="Oval"></path>
      </g>
  </g>
</svg>
)

export default Circle


// WEBPACK FOOTER //
// ./src/assets/svgs/Circle.js